import React from "react";
import PropTypes from "prop-types";

const NoResultIcon = ({className}) => {
	return (
		<svg className={className} width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M38.8989 9.57399C38.0603 9.38051 37.2235 9.90236 37.0294 10.741C36.8353 11.5796 37.3584 12.417 38.197 12.6111C42.074 13.5071 45.6177 15.4755 48.4442 18.302C56.7542 26.612 56.7542 40.1343 48.4442 48.4442C40.1343 56.7548 26.6119 56.7548 18.302 48.4442C9.99146 40.1343 9.99146 26.612 18.302 18.302C20.6879 15.9162 23.5114 14.176 26.6943 13.1287C27.5116 12.8601 27.9565 11.9794 27.688 11.1615C27.4188 10.3436 26.5375 9.89869 25.7202 10.1679C22.0691 11.3684 18.8318 13.3637 16.098 16.098C6.57227 25.6238 6.57227 41.1231 16.098 50.6488C20.8606 55.4114 27.1167 57.793 33.3734 57.793C39.6295 57.7924 45.8856 55.4114 50.6488 50.6488C60.174 41.1231 60.174 25.6238 50.6488 16.098C47.4084 12.8583 43.3459 10.6018 38.8989 9.57399Z'
				fill='currentColor'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M77.8772 67.6105L61.5442 51.2775C69.9194 38.1439 68.0853 20.8893 56.9714 9.77478C50.6683 3.47168 42.2876 0 33.3734 0C24.4586 0 16.0779 3.47168 9.77478 9.77478C3.47107 16.0779 0 24.4586 0 33.3734C0 42.2876 3.47107 50.6683 9.77478 56.9714C16.0779 63.2745 24.458 66.7456 33.3722 66.7456C39.7699 66.7456 45.9326 64.9512 51.2775 61.5442L67.6105 77.8772C68.9771 79.2444 70.8002 79.9969 72.7441 79.9969C74.6875 79.9969 76.5106 79.2444 77.8778 77.8772C80.7074 75.0464 80.7074 70.4413 77.8772 67.6105ZM75.6732 75.6732C74.895 76.4508 73.855 76.8793 72.7441 76.8793C71.6327 76.8793 70.5927 76.4508 69.8145 75.6732L52.5793 58.4381C52.2778 58.136 51.8787 57.9816 51.4771 57.9816C51.1682 57.9816 50.8582 58.0725 50.589 58.2593C45.5249 61.7719 39.5709 63.6285 33.3722 63.6285C25.2905 63.6285 17.6929 60.4816 11.9788 54.7675C0.181885 42.9706 0.181885 23.7756 11.9788 11.9788C17.6935 6.26404 25.2911 3.11707 33.3734 3.11707C41.4551 3.11707 49.0527 6.26404 54.7675 11.9788C65.1239 22.3358 66.593 38.5736 58.2593 50.589C57.8296 51.2085 57.9047 52.0459 58.4381 52.5793L75.6732 69.8145C77.2882 71.4294 77.2882 74.0576 75.6732 75.6732Z'
				fill='currentColor'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M42.782 23.9642C42.1735 23.3557 41.1871 23.3557 40.578 23.9642L33.3734 31.1688L26.1682 23.9642C25.5597 23.3557 24.5728 23.3557 23.9642 23.9642C23.3557 24.5727 23.3557 25.5597 23.9642 26.1682L31.1688 33.3734L23.9642 40.578C23.3557 41.1865 23.3557 42.1734 23.9642 42.7819C24.2682 43.0865 24.6674 43.2385 25.0659 43.2385C25.4651 43.2385 25.8636 43.0865 26.1682 42.7819L33.3728 35.5774L40.5774 42.7819C40.882 43.0865 41.2811 43.2385 41.6797 43.2385C42.0789 43.2385 42.4774 43.0865 42.782 42.7819C43.3905 42.1734 43.3905 41.1865 42.782 40.578L35.5768 33.3734L42.782 26.1682C43.3905 25.5597 43.3905 24.5727 42.782 23.9642Z'
				fill='currentColor'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M32.3401 12.0824C33.1982 12.0824 33.8983 11.3823 33.8983 10.5236C33.8983 9.66541 33.1982 8.96533 32.3401 8.96533C31.4813 8.96533 30.7812 9.66541 30.7812 10.5236C30.7812 11.3823 31.4813 12.0824 32.3401 12.0824Z'
				fill='currentColor'
			/>
		</svg>
	);
};

NoResultIcon.propTypes = {
	className: PropTypes.string,
};

NoResultIcon.defaultProps = {
	className: "",
};
export default NoResultIcon;
